module.exports = __webpack_public_path__ + "img/2.f37f44ce.jpg";